
import {Feature, Map, View} from "ol";
import TileLayer from "ol/layer/Tile";
import {fromLonLat, transformExtent} from "ol/proj";
import {ImageWMS, TileWMS, XYZ} from "ol/source";
import {displayFeatureInfo} from "@/modules/ol-service-wms";
import {OlZoomInComponent} from "@/components/ol/ol-zoom-in-component";
import {OlZoomOutComponent} from "@/components/ol/ol-zoom-out-component";
import ImageLayer from "ol/layer/Image";
import {convertLayerUrl, getCategoryLinkedName, isValidHttpUrl} from "@/helpers/url-helper";
import {removeLayer, setLayerClick} from "@/helpers/ol-layer-helper";
import {createGeoJsonLayer, getDefaultName} from "@/helpers/geo-json-helper";
import {Point} from "ol/geom";
import * as bootstrap from "bootstrap";
import {RotateNorthControl} from "@/components/ol/ol-backgroundlayerswitcher";
import {defaults, ScaleLine} from "ol/control";
import {viewFit} from "@/helpers/ol-view";
import {generateCanvas} from "@/helpers/canvas-helper";
import {loadMeteo} from "@/meteo-helper";
import {generateWmsClick} from "@/helpers/ol-wms-helper";
import {loadMapClick} from "@/helpers/ol-event-helper";
import {mobileCheck} from "@/components/form/form-component";
import {loadGeomDependentList} from "@/helpers/ol-geo-dependent-helper";
import {Fill, Stroke, Style, Text} from "ol/style";
import CircleStyle from "ol/style/Circle";
import {setInfoValue} from "@/helpers/info-overview-helper";
import {GeoJSON} from "ol/format";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import {bbox} from "ol/loadingstrategy";

export class OlComponent extends HTMLElement {
    constructor() {
        super();

        let selected = null
        // Make map global
        // window.map = initMap(this)

        const selectStyle = new Style({
            image: new CircleStyle({
                radius: 5,
                fill: new Fill({
                    color: 'rgba(0, 87, 129, 0.8)',
                }),
                stroke: new Stroke({
                    color: 'rgba(0, 87, 129, 1)',
                    width: 1
                }),
            }),
            text: new Text({
                text: '',
                offsetY: -10,
                scale: 1.5
            })
        });

        const scaleLine = new ScaleLine({
            units: 'metric',
        });

        window.view = new View({
            zoom: 18
        })

        const map = new Map({
            target: this,
            layers: [
                new TileLayer({
                    name: 'water',
                    source: new XYZ({
                        crossOrigin: 'anonymous',
                        url: 'https://a.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}@2x.png'
                    })
                })
            ],
            view: window.view,
            controls: defaults({
                attribution: false
            }).extend([
                new RotateNorthControl(this),
                scaleLine,
            ]),
        });

        if(window.wizard.backgroundLayers.length === 0) {
            const layer = window.wizard.Layer
            map.addLayer(new ImageLayer({
                name: layer.Layer,
                zIndex: layer.zIndex,
                opacity: layer.Opacity / 10,
                minResolution: layer.MinResolution,
                maxResolution: layer.MaxResolution,
                source: new ImageWMS({
                    url: convertLayerUrl(layer.Url),
                    projection: layer.Service.Projection,
                    params: {
                        'LAYERS': layer.Layer,
                        'TILED': false
                    },
                    transition: 0,
                }),
            }))

            if(layer.Legend === '') {
                document.getElementById('divLegend').classList.add('d-none')
            } else {
                document.getElementById('legend').src = convertLayerUrl(layer.Legend)
            }
        }

        const linkedLayer = window.wizard.LinkedLayer
        if(linkedLayer.Layer !== null) {
            map.addLayer(new ImageLayer({
                name: linkedLayer.Layer,
                zIndex: 10,
                opacity: linkedLayer.Opacity / 10,
                minResolution: linkedLayer.MinResolution,
                maxResolution: linkedLayer.MaxResolution,
                source: new ImageWMS({
                    url: convertLayerUrl(linkedLayer.Url),
                    projection: linkedLayer.Service.Projection,
                    params: {
                        'LAYERS': linkedLayer.Layer,
                        'TILED': false
                    },
                    transition: 0,
                }),
            }))

            if(linkedLayer.Legend === '') {
                document.getElementById('divLegendLinked').classList.add('d-none')
            } else {
                document.getElementById('legendLinked').src = convertLayerUrl(linkedLayer.Legend)
            }

            window.categoryNameLinked = linkedLayer.BookmarkGroupName
        } else {
            document.getElementById('divLegendLinked').classList.add('d-none')
        }

        if(mobileCheck()) {
            const collapseElementList = [].slice.call(document.querySelectorAll('.collapse'));
            collapseElementList.map(function (collapseEl) {
                return new bootstrap.Collapse(collapseEl)
            })
        }


        let selectedItem = `
            <div class="alert alert-secondary alert-dismissible fade show">
                <span class="fa fa-circle"></span> Kies een object in de kaart
            </div>`
        if(window.categoryNameLinked === undefined) {
            selectedItem = `
            <div class="alert alert-secondary alert-dismissible fade show">
                <span class="fa fa-map-marker"></span> Klik op de kaart of voer een adres in
            </div>`
        }
        document.getElementById('selectedItem').innerHTML = selectedItem

        map.on('singleclick', function (evt) {

            const coordinate = evt.coordinate;
            const pixel = window.map.getEventPixel(evt.originalEvent);

            let clickedFeature
            map.forEachFeatureAtPixel(pixel, function (f, layer) {
               if(f.get('name')) {
                   clickedFeature = f

                   const element = document.querySelector('form-domain-list-item[data-name="' + f.get('name') + '"]')
                   element.parentElement.querySelectorAll('.list-group-item-action').forEach((element) => {
                       element.classList.remove('active')
                   })
                   element.getElementsByClassName('list-group-item-action')[0].classList.add('active')

                   const id = element.dataset.attributeId
                   setInfoValue(id, f.get('name'))

                   element.scrollIntoView();
               }
            })

            if(clickedFeature) {
                return
            }

            generateWmsClick(pixel)
            // Check if has relation
            if(window.categoryNameLinked !== undefined) {
                displayFeatureInfo(pixel, coordinate);
                generateCanvas()
                loadMapClick(coordinate)
            }
            setLayerClick(coordinate)

            loadGeomDependentList(coordinate)
        });

        map.on('pointermove', function (e) {


            if (selected !== null) {
                selected.setStyle(undefined);
                selected = null;
            }

            map.forEachFeatureAtPixel(e.pixel, function (f) {

                if(f.get('name')){
                    selected = f;
                    selectStyle.getText().setText(f.get('name'));
                    f.setStyle(selectStyle);
                    return true;
                }
                return false

            });
        });

        window.map = map

        window.wizard.backgroundLayers.map(layer => {

            let styles = layer.Styles
            if(Array.isArray(styles)) {
                styles = styles[0]
            }

            if(layer.Layer.includes('Gebiedsbeperking')) {
                map.addLayer(new VectorLayer({
                    name: layer.Layer,
                    opacity: layer.Opacity / 10,
                    source: new VectorSource({
                        url: convertLayerUrl(layer.Url) + 'service=WFS&' +
                            'version=1.1.0&request=GetFeature&typename=' + layer.Layer + '&' +
                            'outputFormat=application/json&srsname=' + layer.Service.Projection + '&' +
                            'FORMAT=JSON',
                        format: new GeoJSON(),
                    })
                }));
            } else {
                map.addLayer(new ImageLayer({
                    name: layer.Layer,
                    zIndex: layer.zIndex,
                    opacity: layer.Opacity / 10,
                    minResolution: layer.MinResolution,
                    maxResolution: layer.MaxResolution,
                    source: new ImageWMS({
                        url: convertLayerUrl(layer.Url),
                        projection: layer.Service.Projection,
                        params: {
                            'LAYERS': layer.Layer,
                            'TILED': false,
                            STYLES: styles
                        },
                        ratio: 1,
                        transition: 0,
                    }),
                }))
            }



        })
    }
}

window.customElements.define("ol-zoom-in", OlZoomInComponent);
window.customElements.define("ol-zoom-out", OlZoomOutComponent);
